import PushSettings from "../../components/PushSettings";
import pushApi from "../pushApi";

export default function MyNotifications() {
  return (
    <div className="max-w-3xl" data-testid="my-notifications-page">
      <div className="mb-6">
        <h1 className="text-2xl text-[#0F1829]" style={{ fontFamily: "'Fraunces', serif", fontWeight: 600 }}>
          Notificações
        </h1>
        <p className="text-sm text-[#6B7280] mt-1">
          Gere as notificações push deste dispositivo.
        </p>
      </div>
      <PushSettings api={pushApi} scope="my" />
    </div>
  );
}
